import React, { useEffect } from "react";
import Check from "../../../src/assets/check.png";

const SuccessModal = ({ show, handleClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        handleClose();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [show, handleClose]);

  if (!show) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button onClick={handleClose} style={styles.closeButton}>
          &times;
        </button>
        <div style={styles.tickContainer}>
          <img src={Check} alt="success" style={styles.tickImage} />
        </div>
        <h4 style={{ marginTop: "15px" }}>Thanks for choosing us!</h4>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    background: "white",
    padding: "30px 20px",
    borderRadius: "12px",
    textAlign: "center",
    width: "320px",
    position: "relative",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    animation: "popIn 0.3s ease",
  },
  tickContainer: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto",
    animation: "scaleIn 0.4s ease",
  },
  tickImage: {
    width: "60px",
    height: "60px",
  },
  closeButton: {
    position: "absolute",
    top: "8px",
    right: "12px",
    background: "transparent",
    border: "none",
    fontSize: "40px",
    cursor: "pointer",
    color: "#888",
  },
};

export default SuccessModal;
